import type { IntlNumberFormats, MessageCompiler } from 'vue-i18n';
import { createI18n } from 'vue-i18n';

import { isFeatureToggleActive } from '@libs/feature-toggle';
import { getDomain } from '@libs/utils';

import EnglishMessages from './lang/en.json';

const numberFormats: IntlNumberFormats = {
  sv: {
    currency: {
      style: 'currency',
      currency: 'sek',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
  },
  en: {
    currency: {
      style: 'currency',
      currency: 'gbp',
    },
  },
  dk: {
    currency: {
      style: 'currency',
      currency: 'dkk',
    },
  },
  pl: {
    currency: {
      style: 'currency',
      currency: 'pln',
    },
  },
};

type KnownLanguage = keyof typeof numberFormats;

export const messageCompiler: MessageCompiler =
  (_, { key }) =>
  () =>
    key;

export const i18n = createI18n({
  messages: {
    en: EnglishMessages,
  },
  locale: getDomain.getCurrentDomainSpec().Locale,
  fallbackLocale: 'en',
  numberFormats,
  globalInjection: true,
  legacy: false,
  missingWarn: false,
  messageCompiler: isFeatureToggleActive('translation-keys')
    ? messageCompiler
    : undefined,
});
document.documentElement.lang = i18n.global.locale.value;

function setI18nLanguage(lang: KnownLanguage): KnownLanguage {
  i18n.global.locale.value = lang;
  return lang;
}

export async function loadLanguageAsync(
  language: string
): Promise<KnownLanguage> {
  return import(
    /* webpackChunkName: "lang-[request]" */ `./lang/${language}.json`
  ).then((msgs) => {
    i18n.global.setLocaleMessage(language, msgs.default);
    return setI18nLanguage(language as KnownLanguage);
  });
}
